import React from 'react';
import { Box, Link, Typography } from '@mui/material';

const FOOTER_LINKS = [
	{ label: 'About', href: 'https://www.untwyn.com' },
	{ label: 'Documentation', href: 'https://www.untwyn.com/docs' },
	{ label: 'Terms & Conditions', href: 'https://www.untwyn.com/terms-and-conditions' },
	{ label: 'Privacy Policy', href: 'https://www.untwyn.com/privacy-policy' },
];

const StatusPageFooter = () => (
	<Box component='footer' display='flex' flexDirection={{ xs: 'column', md: 'row' }} justifyContent='space-between' alignItems='center' gap={{ xs: 1.5, md: 3 }} py={3}>
		<Typography variant='caption' color='text.secondary'>
			Untwyn &middot; {new Date().getFullYear()}
		</Typography>
		<Box display='flex' flexWrap='wrap' justifyContent='center' columnGap={3} rowGap={1}>
			{FOOTER_LINKS.map(({ label, href }) => (
				<Link key={href} href={href} target='_blank' rel='noopener noreferrer' variant='caption' color='text.secondary' underline='hover'>
					{label}
				</Link>
			))}
		</Box>
	</Box>
);

export default StatusPageFooter;
